export default __webpack_public_path__ + "static/media/smartphone.b509b8de.svg";